import React, { Component } from 'react'
import InputMask from 'react-input-mask'
import moment from 'moment'

import Title from '../common/title'
import AriaMessage from '../common/ariaMessage'
import Privacy from '../common/privacy'
import Controls from '../common/controls'
import RadioButton from '../common/radioButton'
import RadioGroup from '../common/radioGroup'
import RegexVerification from './regex_verification'
import Checkbox from '../common/checkbox'

export default class Registration3 extends Component {
  constructor(props) {
    super(props)

    this.required = {
      fName2: { required: !this.props.UseNameForVerification || (this.props.UseEmployeeSpouseSelection && this.props.history.location.state.spouseSelection.value === 'true') },
      lName2: { required: !this.props.UseNameForVerification || (this.props.UseEmployeeSpouseSelection && this.props.history.location.state.spouseSelection.value === 'true') },
      dob: { required: !this.props.UseDOBForVerification },
      email: { required: true },
      country: {required: true},
      address1: {required: true},
      address2: {required: false},
      state: {required: true},
      city: {required: true},
      zip: {required: true},
      postal: {required: true},
      timezone: {required: true},
      isDST: {required: true},
      phone: {required: true},
      mobilePhone: {required: true},
      smsOptIn: {required: true}
    }

   	this.state = {
    	input: { 
        fName2: { value: '', type: 'text' },
        lName2: { value: '', type: 'text' },
        email: { value: '', type: 'text' },
        dob: { value: '', type: 'text' },
        country: { value: 'USA', type: 'text' },
        address1: { value: '', type: 'text' },
        address2: { value: '', type: 'text' },
        state: { value: '', type: 'text' },
        city: { value: '', type: 'text' },
        zip: { value: '', type: 'text' },
        postal: { value: '', type: 'text' },
        timezone: { value: '', type: 'text' },
        isDST: { value: '', type: 'radio' },
        phone: { value: '', type: 'text' },
        mobilePhone: { value: '', type: 'text' },
        smsOptIn: { value: false, type: 'checkbox' }
      },
      submitClick: false,
      emailUnique: true
    }

    this.focusElements = {}

    for (let name in this.state.input) {
      this.focusElements[name] = React.createRef()
    }

    this.next = this._next.bind(this)
    this.back = this._back.bind(this)
    this.updateFromHistory = this._updateFromHistory.bind(this)
    this.props.updateActivePage(2)
  }

  handleChange(name, valueOrEvent) {
    switch (this.state.input[name].type) {
      case 'text':
        const curInputValue = valueOrEvent.target.value
        this.handleStateChange(name, curInputValue)
        break
      case 'checkbox':
        this.handleStateChange(name, !this.state.input[name].value)
        break
      case 'radio':
        this.handleStateChange(name, valueOrEvent)
        break
      default: break
    }
  }

  handleStateChange(name, value) {
    this.setState({
      input: { ...this.state.input,
        [name]: {...this.state.input[name], 
          value: value 
        }
      }
    }, () => {
      this.props.replaceHistoryState(this.state, this.props.history)
    })
  }

  async _next(e) {
    e.preventDefault()
    let verified = !this.isValid('email') || await this.props.verifyEmail(this.props.history, null) 
    if (verified) {
      this.setState({ 
        submitClick: true,
        emailUnique: true 
      })
      for (let property in this.state.input) {
        if ((this.state.input.country.value === 'USA' && property === 'postal') || (this.state.input.country.value === 'Canada' && property === 'zip'))  
          continue
        if (this.required[property].required && !this.isValid(property) && property !== 'smsOptIn' && this.focusElements[property]) {
          this.focusElements[property].focus()
          return
        }
      }
      return this.props.next(this.props.match.path, this.state)
    }
    else {
      this.setState({ 
        submitClick: true,
        emailUnique: false 
      })
      this.focusElements['email'].focus()
      return
    }
  }

  _back(e) {
    return this.props.back(this.props.match.path, this.state)
  }

  isEmpty(name) {
    if(this.state.input[name].value === '') return true
    return false
  }

  isValid(name) {
    if (name === 'dob') {
      const parsedDob = this.parseDob(this.state.input.dob.value)
      let dob = moment(parsedDob)
      let yearsOld = moment().diff(parsedDob, 'years')
      let oldestDate = moment('1900-01-01')
      if (yearsOld >= 18 && oldestDate <= dob) {
        return true
      }
      return false
    }
    if ((this.state.input.country.value === 'USA' && name === 'postal') || (this.state.input.country.value === 'Canada' && name === 'zip'))  
      return
    switch (this.state.input[name].type) {
      case 'radio':
        return !this.isEmpty(name)
      case 'text':
        return this.state.input[name].value.match(/^ *$/) == null && RegexVerification[name].test(this.state.input[name].value)
      default:
    } 
  }

  parseDob(dob) {
    let newDate = dob.split('/').reverse()
    const day = newDate[1]
    newDate[1] = newDate[2]
    newDate[2] = day
    return newDate.join('-')
  }

  displayErrors(name, errorId) {
    if (this.state.submitClick) {
      if(!this.state.emailUnique && name === 'email'){
        return (
          <div id={errorId} className="error">This email id is already registered with Newtopia. Please use another email or Call Client Care at 1-888-639-8181.</div>
        )
      }
      if (!this.isValid(name) && this.isEmpty(name)) {
        switch (name) {
          case 'address2':
              return
          default:
            return (
              <div id={errorId} className="error">This field is required.</div>
            )
        }
      } else if (!this.isValid(name)) {
        switch (name) {
          case 'address2':
              return
          default:
            return (
              <div id={errorId} className="error">Invalid input.</div>
            )
        }
      } else if (this.isEmpty(name)) {
        switch (name) {
          case 'address2':
              return
          default:
            return (
              <div id={errorId} className="error">This field is required.</div>
            )
        }
      }
    }
    return (
      <div id={errorId} className="error"></div>
    )
  }

  makeRef(name, ref) {
    this.focusElements[name] = ref
  }

  _updateFromHistory() {
    if (this.props.history.location.state) {
      const historyState = this.props.history.location.state
      let newInputState = {}
      for (let property in this.state.input) {
        if (historyState[property]) {
            newInputState[property] = historyState[property]
          }
        }
      if (!historyState.country) {
        newInputState.country = {
          value: historyState.Default_Country__c ? historyState.Default_Country__c : 'USA',
          type: 'text'
        }
      } else if (historyState.country && historyState.country.value) {
        newInputState.country = historyState.country
      }
      
      this.setState({ 
        input: { ...this.state.input,
          ...newInputState
        }
      })
    }
  }

  componentDidMount() {
    var focusable = document.querySelectorAll('[tabindex]:not([tabindex="-1"])');
    focusable && focusable[0] && focusable[0].focus()
    this.updateFromHistory()
    window.scrollTo(0, 0)
  }

  render() {
    const { 
      input: { 
        country 
      } 
    } = this.state
    const countryList = ['USA', 'Canada']
    const stateList = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming', 'District of Columbia']
    const provinceList = ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador', 'Northwest Territories', 'Nunavut', 'Nova Scotia', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Yukon']
    const timezoneList = ['Atlantic', 'Eastern', 'Central', 'Mountain', 'Pacific', 'Alaska', 'Hawaii', 'Newfoundland']
    
    const states = stateList.map(state => 
      <option value={state} selected={this.state.input.state.value === state ? "selected" : null} key={state}>{state}</option>
    ) 
    states.unshift(<option value="initial" role="option" disabled hidden>Select your state here</option>)

    const provinces = provinceList.map(state => 
      <option value={state} selected={this.state.input.state.value === state ? "selected" : null} key={state}>{state}</option>
    )
    provinces.unshift(<option value="initial" role="option" disabled hidden>Select your province here</option>)

    const timezones = timezoneList.map(timezone =>
      <option value={timezone} selected={this.state.input.timezone.value === timezone ? "selected" : null} key={timezone}>{timezone}</option>
    )
    const countries = countryList.map(country =>
      <option value={country} selected={this.state.input.country.value === country ? "selected" : null} key={country}>{country}</option>
    )
    let isDSTInitial = ""
    const smsLine = <span>I agree to receive text alerts and reminders from Newtopia. Message and data rates may apply. Message frequency varies. Text OPTOUT to {country.value === 'USA' ? '82426' : '28767'} to unsubscribe. View our <a href="https://www.newtopia.com/b2c/mobile-text-alert-authorization-and-terms-of-service/" target="_blank" rel="noopener noreferrer">terms & conditions</a></span>
    const displayNames = !this.props.UseNameForVerification || (this.props.UseEmployeeSpouseSelection && this.props.history.location.state.spouseSelection.value === 'true')
    
    const historyState = this.props.history.location.state
    if (historyState && historyState.isDST) {
        isDSTInitial = historyState.isDST.value
    }

    return (
      <div id="registration_3">
        <AriaMessage message="Navigated to registration page 3" />
        <Title>Your Profile</Title>
        <div className="container">
          <h2>Let's build your profile.</h2>
          { displayNames &&
            <div className="form-row">
              <div className="form-input">
                <label for="first-name" id="registration_p1_first_name_text" className="form-heading"> First Name </label>
                <input
                  name="first-name"
                  ref={this.makeRef.bind(this, "fName2")}
                  value={this.state.input.fName2.value}
                  type="text"
                  id="registration_p1_first_name"
                  placeholder="Enter name here"
                  aria-labelledby="registration_p1_first_name_text"
                  aria-describedby="registration_p1_first_name_error"
                  onChange={this.handleChange.bind(this, "fName2")}
                  data-atid="reg_p1_first_name" 
                />
                {this.displayErrors("fName2", "registration_p1_first_name_error")}
              </div>
              <div className="form-input">
                <label for="registration_p1_last_name" id="registration_p1_last_name_text" className="form-heading"> Last Name </label>
                <input
                  ref={this.makeRef.bind(this, "lName2")}
                  value={this.state.input.lName2.value}
                  type="text"
                  id="registration_p1_last_name"
                  placeholder="Enter name here"
                  aria-labelledby="registration_p1_last_name_text"
                  aria-describedby="registration_p1_last_name_error"
                  onChange={this.handleChange.bind(this, "lName2")}
                  data-atid="reg_p1_last_name" 
                />
                {this.displayErrors("lName2", "registration_p1_last_name_error")}
              </div>
            </div>
          }
          <div className="form-input">
            <div id="registration_p3_email_text">
              <label for="registration_p3_email">
                <div className="form-heading">
                  Email
                </div>
                <div>
                  Please enter your <b>personal email</b> for Newtopia to communicate with you.
                </div>
              </label>
            </div>
            <input
              ref={this.makeRef.bind(this, "email")}
              value={this.state.input.email.value}
              id="registration_p3_email"
              type="text"
              placeholder="Enter email here"
              aria-labelledby="registration_p3_email_text"
              aria-describedby="registration_p3_email_error"
              onChange={this.handleChange.bind(this, "email")}
              data-atid="reg_p3_email"
            />
            {this.displayErrors("email", "registration_p3_email_error")}
          </div>
          { !this.props.UseDOBForVerification &&
            <div className="form-input">
              <div id="registration_p1_dob_text">
                <label for="registration_p1_dob"> 
                  <div className="form-heading">
                    Date of Birth 
                  </div>
                  <div>
                    Please enter your date of birth in the format of MM/DD/YYYY.
                  </div>
                </label>
              </div>
              <InputMask
                id="registration_p1_dob"
                mask="99/99/9999"
                className="form-input-text"
                value={this.state.input.dob.value}
                placeholder="MM/DD/YYYY"
                aria-labelledby="registration_p1_dob_text"
                aria-describedby="registration_p1_dob_error"
                onChange={this.handleChange.bind(this, "dob")}
                inputRef={this.makeRef.bind(this, "dob")}
                data-atid="reg_p1_dob"
              />
              {this.displayErrors("dob", "registration_p1_dob_error")}
            </div>
          }
          <div className="form-input">
            <label for="registration_p3_country" id="registration_p3_country_text" className="form-heading">Country</label>
            <select
              ref={this.makeRef.bind(this, "country")}
              id="registration_p3_country"
              defaultValue={country.value}
              aria-label="Select your country here"
              aria-describedby="registration_p3_country_error"
              onChange={this.handleChange.bind(this, "country")}
              data-atid="reg_p3_country"
            >
              <option value="initial" role="option" disabled hidden>Select your country here</option>
              {countries}
            </select>
            {this.displayErrors("state", "registration_p3_country_error")}
          </div>
          <div className="form-input">
            <div id="registration_p3_address_required_text">
              <label for="registration_p3_address_required">
                <div className="form-heading">
                  Address
                </div>
                <div>
                  Enter the address to which you want us to ship your Welcome Kit.
                </div>
              </label>
            </div>
            <input
              ref={this.makeRef.bind(this, "address1")}
              value={this.state.input.address1.value}
              id="registration_p3_address_required"
              type="text"
              placeholder="Address Line 1"
              aria-labelledby="registration_p3_address_required_text"
              aria-describedby="registration_p3_address_required_error"
              onChange={this.handleChange.bind(this, "address1")}
              data-atid="reg_p3_address1"
            />
            {this.displayErrors("address1", "registration_p3_address_required_error")}
            <input
              ref={this.makeRef.bind(this, "address2")}
              value={this.state.input.address2.value}
              id="registration_p3_address_optional"
              type="text"
              placeholder="Address Line 2 (optional)"
              aria-label="Address Line 2 (optional)"
              aria-describedby="registration_p3_address_optional_error"
              onChange={this.handleChange.bind(this, "address2")}
              data-atid="reg_p3_address2"
            />
            {this.displayErrors("address2", "registration_p3_address_optional_error")}
          </div>
          <div className="form-input">
            <label for="registration_p3_state" id="registration_p3_state_text" className="form-heading">{country.value ==='USA' ? 'State' : 'Province'}</label>
            <select
              ref={this.makeRef.bind(this, "state")}
              id="registration_p3_state"
              defaultValue="initial"
              aria-label={'Select your ' + (country.value === 'USA' ? 'state' : 'province') + ' here'}
              aria-describedby="registration_p3_state_error"
              onChange={this.handleChange.bind(this, "state")}
              data-atid="reg_p3_state_province"
            >
              {country.value === 'USA' ? states : provinces}
            </select>
            {this.displayErrors("state", "registration_p3_state_error")}
          </div>
          <div className="form-input">
            <label for="registration_p3_city" id="registration_p3_city_text" className="form-heading">City</label>
            <input
              ref={this.makeRef.bind(this, "city")}
              value={this.state.input.city.value}
              id="registration_p3_city"
              type="text"
              placeholder="Enter city name here"
              aria-labelledby="registration_p3_city_text"
              aria-describedby="registration_p3_city_error"
              onChange={this.handleChange.bind(this, "city")}
              data-atid="reg_p3_city"
            />
            {this.displayErrors("city", "registration_p3_city_error")}
          </div>
          {country.value === 'USA' ?
            <div className="form-input">
              <label for="registration_p3_zip" id="registration_p3_zip_text">
                <div className="form-heading">
                  Zip Code                
                </div>
                <p id="registration_p3_zip_description" className="no-visibility" tabIndex="-1">5 digits or ZIP+4 format</p>
              </label>
              <input
                ref={this.makeRef.bind(this, "zip")}
                value={this.state.input.zip.value}
                id="registration_p3_zip"
                type="text"
                placeholder="XXXXX or XXXXX-YYYY"
                aria-labelledby="registration_p3_zip_text"
                aria-describedby="registration_p3_zip_description registration_p3_zip_error"
                onChange={this.handleChange.bind(this, "zip")}
                data-atid="reg_p3_zip"
              />
              {this.displayErrors("zip", "registration_p3_zip_error")}
            </div> :
            <div className="form-input">
              <label for="registration_p3_postal" id="registration_p3_postal_text">
                <div className="form-heading">
                  Postal Code
                </div>
                <p id="registration_p3_postal_description" className="no-visibility" tabIndex="-1">6 character format</p>
              </label>
              <input
                ref={this.makeRef.bind(this, "postal")}
                value={this.state.input.postal.value}
                id="registration_p3_postal"
                type="text"
                placeholder="XNXNXN"
                aria-labelledby="registration_p3_postal_text"
                aria-describedby="registration_p3_postal_description registration_p3_postal_error"
                onChange={this.handleChange.bind(this, "postal")}
                data-atid="reg_p3_postal"
              />
              {this.displayErrors("postal", "registration_p3_postal_error")}
            </div>
          }
          <div className="form-input">
            <label for="registration_p3_timezone" id="registration_p3_timezone_text" className="form-heading">Timezone</label>
            <select
              ref={this.makeRef.bind(this, "timezone")}
              id="registration_p3_timezone"
              defaultValue="initial"
              aria-label="Select your timezone here"
              aria-describedby="registration_p3_timezone_error"
              onChange={this.handleChange.bind(this, "timezone")}
              data-atid="reg_p3_timezone"
            >
              <option value="initial" role="option" disabled hidden>Select your timezone here</option>
              {timezones}
            </select>
            {this.displayErrors("timezone", "registration_p3_timezone_error")}
          </div>
          <div className="form-input">
            <h3 id="registration_p3_dst_text">Is Daylight saving time (DST) observed in your location?</h3>
            <RadioGroup
              name="isDST"
              initial={isDSTInitial}
              ariaLabelledby="registration_p3_dst_text"
              radioRef={this.makeRef.bind(this, "isDST")}
              ariaDescribedby="registration_p3_dst_error"
              onChange={this.handleChange.bind(this, "isDST")}
              dataAtId="reg_p3_isdst"
            >
              <RadioButton value="true" label="Yes" />
              <RadioButton value="false" label="No" />
            </RadioGroup>
            {this.displayErrors("isDST", "registration_p3_dst_error")}
          </div>
          <div className="form-input">
            <label for="registration_p3_primary_phone" id="registration_p3_primary_phone_text" className="form-heading">Primary Phone Number</label>
            <InputMask
              id="registration_p3_primary_phone"
              value={this.state.input.phone.value}
              mask="(999) 999-9999"
              className="form-input-text"
              placeholder="Enter number here"
              aria-labelledby="registration_p3_primary_phone_text"
              aria-describedby="registration_p3_primary_phone_error"
              onChange={this.handleChange.bind(this, "phone")} 
              inputRef={this.makeRef.bind(this, "phone")}
              data-atid="reg_p3_primary_phone"
            />
            {this.displayErrors("phone", "registration_p3_primary_phone_error")}
          </div>
          <div className="form-input">
            <div id="registration_p3_mobile_phone_text">
              <label for="registration_p3_mobile_phone">
                <div className="form-heading">
                  Mobile Phone Number
                </div>
                <div>
                  If you already provided your cell number as Primary Phone Number, enter 
                  <br></br>
                  the same phone number in field Mobile Phone Number.
                </div>
              </label>
            </div>
            <InputMask
              id="registration_p3_mobile_phone"
              value={this.state.input.mobilePhone.value}
              mask="(999) 999-9999"
              className="form-input-text"
              placeholder="Enter number here"
              aria-labelledby="registration_p3_mobile_phone_text"
              aria-describedby="registration_p3_mobile_phone_error"
              onChange={this.handleChange.bind(this, "mobilePhone")} 
              inputRef={this.makeRef.bind(this, "mobilePhone")}
              data-atid="reg_p3_mobile_phone"
            />
            {this.displayErrors("mobilePhone", "registration_p3_mobile_phone_error")}
            <br/>
            <Checkbox
              checkboxRef={this.makeRef.bind(this, "smsOptIn")}
              checked={this.state.input.smsOptIn.value}
              onChange={this.handleChange.bind(this, "smsOptIn")}
              value="sms-opt-in"
              ariaDescribedby="registration_p4_smsOptIn_error"
              info={smsLine}
              dataAtId="reg_p3"
            />
          </div>
          <Privacy />
          <Controls 
            back={this.back} 
            next={this.next} 
            dataAtId="reg_p3"
          />
        </div>
      </div>

    )
  }
}